export default __webpack_public_path__ + "static/Easy_EasyTipster-d6d66c3b6bbfd3595b2fa14561b4b059.png";